module.exports = __webpack_public_path__ + "img/email-img.0c40db9c.svg";